'use strict';

if (!Promise.allSettled) {

    Promise.allSettled = function (promises) {

        return Promise.all(promises.map(function (p) {

            return Promise.resolve(p)
                .then(function (value) {
                        return {
                            state: 'fulfilled',
                            value: value
                        }
                    },

                    function (reason) {
                        return {
                            state: 'rejected',
                            reason: reason
                        }
                    }
                );

        }));

    };

}